import { InboxComponent } from './../Inbox.component';
import { InboxFolder } from '../InboxInterfaces/InboxFolder';
import { filterTypes, InboxParams } from '../InboxInterfaces/inboxParams';
import { InboxMessage } from '../InboxInterfaces/inboxMessage';
import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { InboxService } from 'src/app/services/InboxService.service';

@Component({
  selector: 'app-inboxList',
  templateUrl: './inboxList.component.html',
  styleUrls: ['./inboxList.component.less'],
})
export class InboxListComponent implements OnInit {
  totalPages = 0;
  nowPage = 0;
  pagesArray: number[] = [];
  totalRecords = 0;
  filteredRecords = 0;
  folderCode = '';
  option = 'Subject';
  Sortby = 'Code';
  filterText = '';
  folders: InboxFolder[] = [];
  isCollapsed = false;
  isInboxCollapsed: boolean;
  public innerWidth: any;
  folderObject: InboxFolder = {
    Amount: 0,
    Class: '',
    Code: '0',
    Icon: 'fa-inbox',
    Name: 'Inbox',
  };
  messageClicked = false;
  messages: InboxMessage[] = [];
  InboxParams: InboxParams = {
    filters: {},
    page: 0,
    pageSize: 20,
    sortByDir: 'DESC',
    sortByField: 'Code',
    term: '',
  };
  @Output() nzPageIndexChange: EventEmitter<number> = new EventEmitter();
  @Output() nzPageSizeChange: EventEmitter<number> = new EventEmitter();
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  constructor(
    private inboxService: InboxService,
    private route: ActivatedRoute,
    private router: Router,
    private inboxComponent: InboxComponent
  ) { }

  ngOnInit() {
    this.inboxService.updateInboxEmitter.subscribe(() => {
      this.getInboxMessages(this.InboxParams, this.folderCode);
    });
    this.innerWidth = window.innerWidth;
    this.route.params.subscribe((param) => {
      console.log(param);
    });
    this.route.queryParams.subscribe((data) => {
      this.inboxService.getInboxFolders().subscribe((folder) => {
        this.folders = folder.rowsArray;
        if (data.folder) {
          const foldName = folder.rowsArray.find(
            (x) => x.Name.toLowerCase() === data.folder.toLowerCase()
          );
          this.folderObject = foldName;
          this.folderCode = this.folderObject.Code;
        } else {
          this.folderCode = '0';
        }

        this.getInboxMessages(this.InboxParams, this.folderCode);
      });
    });

    this.nowPage = this.InboxParams.page;
  }
  openMessageDetails(Code: string) {
    this.router
      .navigate(['Details/' + Code], {
        relativeTo: this.route,
        queryParamsHandling: 'merge',
      })
      .then(() => {
        this.getInboxMessages(this.InboxParams, this.folderCode);
        if (this.innerWidth < 1000) {
          this.isCollapsed = true;
        }
      });
  }

  getInboxMessages(inboxParams: InboxParams, folder: string) {
    this.inboxService.getInbox(inboxParams, folder).subscribe(
      (data) => {
        this.messages = data.data;
        this.totalRecords = data.recordsTotal;
        this.filteredRecords = data.recordsFiltered;
        this.totalPages = this.filteredRecords / this.InboxParams.pageSize;
        this.pagesArray = Array(Math.round(this.totalPages))
          .fill(0)
          .map((x, i) => i);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  changePageNav(pageNumber: any) {
    this.InboxParams.page = pageNumber - 1;
    this.getInboxMessages(this.InboxParams, this.folderCode);
  }

  changePageSize(newSize: number) {
    this.InboxParams.pageSize = newSize;
    this.getInboxMessages(this.InboxParams, this.folderCode);
  }
  removeFromString(str: string) {
    const newStr = str
      .replace('<span class="msg-subject">', '')
      .replace('</span>', '');
    return newStr;
  }

  changeStarringStatues(messageId: string, status: string) {
    this.inboxService.StarringMessage(messageId, status).subscribe(() => {
      this.getInboxMessages(this.InboxParams, this.folderCode);
    });
  }

  DeleteMessage(MessageId: string) {
    this.inboxService.DeleteMessage(MessageId).subscribe(() => {
      this.getInboxMessages(this.InboxParams, this.folderCode);
    });
  }
  filterTextChange(filterText: string) {
    this.InboxParams.filters = {};
    if (filterText === '') {
      delete this.InboxParams.filters.U_NAME;
      delete this.InboxParams.filters.Subject;

      this.InboxParams.filters.Code = {
        ValueFrom: '*',
        ValueTo: '*',
        filterType: filterTypes.String,
        singleValue: '*',
      };
    } else {
      this.InboxParams.filters.Subject = {
        singleValue: filterText,
        ValueTo: '*',
        ValueFrom: '*',
        filterType: filterTypes.String,
      };
    }
    this.updateInboxParams();
  }
  collapseSide() {
    this.isCollapsed = true;
  }
  CollabseFolderSide() {
    this.inboxComponent.isCollapsed = !this.inboxComponent.isCollapsed;
    this.isInboxCollapsed = this.inboxComponent.isCollapsed;
  }
  updateInboxParams() {
    this.getInboxMessages(this.InboxParams, this.folderCode);
  }
  onOptionsSelected(value: string) {
    switch (value) {
      case 'U_NAME': {
        this.Sortby = 'From';
        break;
      }
      case 'RecDate': {
        this.Sortby = 'Date';
        break;
      }
      case 'Not Read': {
        this.Sortby = 'WasRead';
        break;
      }
      case 'WasRead': {
        this.Sortby = 'Not Read';
        break;
      }
      default: {
        this.Sortby = value;
        break;
      }
    }
    this.InboxParams.sortByField = value;

    this.getInboxMessages(this.InboxParams, this.folderCode);
  }
}
